import { useEffect, useState } from "react";

import { readOnlineStatus, subscribeToConnectivity } from "@/pwa/connectivity.mjs";

export function PwaOfflineState() {
  return (
    <main
      className="flex min-h-[100dvh] w-full items-center justify-center bg-[#FAF7F2] px-6 py-12 text-center text-[#2C2621]"
      style={{
        paddingTop: "max(3rem, env(safe-area-inset-top, 0px))",
        paddingRight: "max(1.5rem, env(safe-area-inset-right, 0px))",
        paddingBottom: "max(3rem, env(safe-area-inset-bottom, 0px))",
        paddingLeft: "max(1.5rem, env(safe-area-inset-left, 0px))",
      }}
      aria-live="assertive"
      data-testid="pwa-offline-state"
    >
      <section className="mx-auto flex max-w-md flex-col items-center">
        <img
          src="/android-chrome-192x192.png"
          alt="Anokina Studio"
          width="112"
          height="112"
          className="h-28 w-28 object-contain"
        />
        <h1 className="mt-7 font-serif text-3xl font-semibold leading-tight sm:text-4xl">
          Нет соединения с интернетом.
        </h1>
        <p className="mt-4 max-w-sm text-base leading-relaxed text-[#67584E] sm:text-lg">
          Для работы с Anokina Studio требуется подключение.
        </p>
      </section>
    </main>
  );
}

export default function PwaConnectivityGate({ children }) {
  const [online, setOnline] = useState(() => readOnlineStatus());

  useEffect(() => subscribeToConnectivity(setOnline), []);

  return online ? children : <PwaOfflineState />;
}
